import { useActiveCharacterStore } from '../sim/active-character';
import { debugIdsEnabled, jobDisplayName } from './item-display';
import styles from './ActiveCharacterBanner.module.css';

/**
 * One-line indicator for the currently-active save slot. Sits in Layout
 * just under the page header so the player always sees who they're
 * playing as. If the store carries an error from a failed mutation,
 * we surface it inline in red.
 *
 * Phase 3 Step 8 (2/4).
 */
export function ActiveCharacterBanner() {
  const active = useActiveCharacterStore((s) => s.active);
  const error = useActiveCharacterStore((s) => s.error);

  if (active === null) {
    return (
      <div className={styles.banner} data-testid="active-character-banner">
        <span className={styles.empty}>
          No active character. Activate one from Settings.
        </span>
        {error !== null && <span className={styles.error}>Error: {error}</span>}
      </div>
    );
  }

  const jobId = active.character.jobId;
  const jobName = jobDisplayName(jobId);
  const debugIds = debugIdsEnabled();

  return (
    <div className={styles.banner} data-testid="active-character-banner">
      <span className={styles.label}>Active:</span>{' '}
      <strong className={styles.name}>{active.name}</strong>
      <span className={styles.sep}> · </span>
      <span>Lv {active.character.jobLevel}</span>
      <span className={styles.sep}> · </span>
      <span>
        {jobName}
        {debugIds && <code className={styles.jobId}> ({jobId})</code>}
      </span>
      <span className={styles.sep}> · </span>
      <span data-testid="active-gold">{active.character.gold}g</span>
      <span className={styles.sep}> · </span>
      <span data-testid="active-xp">{active.character.xp} xp</span>
      {error !== null && <span className={styles.error}>Error: {error}</span>}
    </div>
  );
}
